import React from 'react'
import { ListItem, ListItemText, ListItemIcon } from '@material-ui/core'
import useStyles from '../../useStyles'
import { Strings } from '../../../assets/res/en'
import { Launch } from '@material-ui/icons'

const useZendesk = (zendeskDomain) => {
    const classes = useStyles()
    return [
        {
            title: Strings.ZENDESK_TICKET_CREATE,
            linkTo: '/agent/tickets/new/0'
        },
        {
            title: Strings.ZENDESK_TICKET_VIEW,
            linkTo: '/agent/dashboard'
        }].map(item => (
            <ListItem key={item.title}
                alignItems="center"
                component="a"
                href={`${zendeskDomain}${item.linkTo}`}
                target="_blank"
                disableGutters dense
                className={classes.linkList}>
                <ListItemIcon className={classes.smallWidthItemIcon}>
                    <Launch />
                </ListItemIcon>
                <ListItemText primary={item.title} classes={{ primary: classes.smallFont }} />
            </ListItem>
        ))
}
export default useZendesk


